import React from "react";
import { BOBA_MENU, BG } from "../lib/brand";

export default function Boba() {
  return (
    <section
      id="boba"
      data-testid="boba-section"
      className="relative overflow-hidden bg-[#050505] py-24 sm:py-32"
    >
      <div
        className="absolute inset-y-0 right-0 -z-0 hidden w-1/2 bg-cover bg-center opacity-30 lg:block"
        style={{ backgroundImage: `url(${BG.bobaHero})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/90 to-black/30" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 max-w-2xl">
          <div className="mb-3 text-xs uppercase tracking-[0.3em] text-[#E11D2A]">Boba Bar</div>
          <h2 className="font-display text-4xl tracking-widest text-[#F5F5DC] sm:text-5xl lg:text-6xl">
            Sip Like a <span className="text-[#E11D2A]">Sifu</span>
          </h2>
          <p className="mt-6 text-base text-[#A1A1AA] sm:text-lg">
            House-brewed teas, fresh fruit blends and chewy tapioca pearls. Pair
            any drink with your pack-pop or game night.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {BOBA_MENU.map((d) => (
            <div
              key={d.name}
              data-testid={`boba-card-${d.name.replace(/\s+/g, "-").toLowerCase()}`}
              className="group border border-[#27272A] bg-[#121212]/80 p-6 backdrop-blur transition-colors hover:border-[#E11D2A]"
            >
              <div className="flex items-baseline justify-between">
                <h3 className="font-display text-2xl tracking-wider text-[#F5F5DC]">
                  {d.name}
                </h3>
                <span className="font-display text-xl tracking-wider text-[#E11D2A]">
                  {d.price}
                </span>
              </div>
              <p className="mt-3 text-sm text-[#A1A1AA]">{d.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
